//Helper Functions for Apollo GraphQL Response Transformers

import { timePeriodOptions } from '../components/Filter/TableFilters';
import { mapWeekFilterToEnum } from '../components/Table/generateColumnsDefs';
import { getState } from '../redux/sagas/itemDrillDown/itemDrillDownSaga';
import { CUSTOM_ATTR } from '../constants/constant';

export const appendTimePeriodPrefix = (obj, weekFilter) => {
	const excludedKeys = [
		'id',
		'name',
		'group',
		'level',
		'upcNbr',
		'wmtItemNo',
		'catalogItemId',
		'primeItemNbr',
		'allLinkNbr',
		'fullWidth',
		'totalRows',
		'hierarchyLevel',
		'sort',
		'rootParam',
		'description',
		'type',
		'standardName',
	];
	// Fetch the timePeriodValue, Map it to ENUM value
	let timePeriodValue = mapWeekFilterToEnum(weekFilter, timePeriodOptions);

	// Append underscore as the prefix
	const prefix = timePeriodValue.value + `_`;

	// Loop over all keys to add the prefix, except the excluded main keys
	for (let key in obj) {
		if (!excludedKeys.includes(key)) {
			obj[prefix + key] = obj[key];
			delete obj[key];
		}
	}

	return obj;
};

export const appendTimePeriodPrefixDirect = (obj, inputPrefix) => {
	const excludedKeys = [
		'id',
		'name',
		'group',
		'level',
		'upcNbr',
		'wmtItemNo',
		'catalogItemId',
		'primeItemNbr',
		'allLinkNbr',
		'fullWidth',
		'totalRows',
		'hierarchyLevel',
		'sort',
		'description',
		'type',
		'standardName',
	];

	// Append underscore as the prefix
	const prefix = inputPrefix + `_`;

	// Loop over all keys to add the prefix, except the excluded main keys
	for (let key in obj) {
		if (!excludedKeys.includes(key)) {
			obj[prefix + key] = obj[key];
			delete obj[key];
		}
	}

	return obj;
};

export const capitalizeString = (text) => {
	return text
		.split(' ')
		?.map(
			(word) => word.substr(0, 1).toUpperCase() + word.substr(1, word.length)
		)
		.join(' ');
};

export const formatName = (tableRow, level, type) => {
	// Check if the table row level is State
	if (level === 'STATE') {
		return getState(tableRow?.id);
	}

	if (['ITEM', 'BRAND', 'PRIME_ITEM_NUMBER', 'ALL_LINK_NUMBER'].includes(level) || type === CUSTOM_ATTR) {
		return tableRow?.name;
	}

	// Format the name
	let itemName = '';
	if (tableRow?.name) {
		itemName = capitalizeString(tableRow?.name?.toLocaleLowerCase());
	}

	// Format the id
	let itemId = '';
	if (tableRow?.id && level != 'SUB_DIVISION') {
		itemId = String(tableRow?.id).padStart(2, '0');
	} else if(tableRow?.id) {
		itemId = String(tableRow?.id);
	}

	// Conditional rendering
	if (itemId !== '' && itemName !== '') {
		return `${itemId} ${itemName}`;
	} else if (itemName !== '') {
		return itemName;
	} else if (itemId !== '') {
		return itemId;
	} else {
		return '-';
	}
};
n